export const TRACKING_CONSENTS_SET = 'TRACKING_CONSENTS_SET';
export const TRACKING_CONSENTS_READY = 'TRACKING_CONSENTS_READY';
